import React from "react"
import PropTypes from "prop-types"
import tw, { styled } from "twin.macro"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Section = styled.section`
  ${tw`relative z-10 overflow-hidden bg-white py-c68 2xl:pb-c120 2xl:pt-c145`}
`

const LogoTrack = styled.div`
  ${tw`relative w-full overflow-hidden`}
`

const LogoRow = styled.div`
  ${tw`flex items-center gap-8 py-4`}
  ${({ direction }) => `
    display: flex;
    position: relative;
    width: fit-content;
    
    &::before,
    &::after {
      content: "";
      ${tw`absolute top-0 z-10 w-8 h-full`}
    }
    
    &::before {
      ${tw`left-0 bg-gradient-to-r from-white to-transparent`}
    }
    
    &::after {
      ${tw`right-0 bg-gradient-to-l from-white to-transparent`}
    }

    & > div {
      animation: ${
        direction === "left" ? "scroll-left" : "scroll-right"
      } 120s linear infinite;
    }

    @keyframes scroll-left {
      0% { transform: translateX(0); }
      100% { transform: translateX(-100%); }
    }

    @keyframes scroll-right {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(0); }
    }
  `}
`

const LogoStrip = styled.div`
  ${tw`flex items-center gap-c60`}
  min-width: max-content;
`

const LogoContainer = styled.div`
  ${tw`flex items-center justify-center min-w-[150px] max-w-100 md:max-w-max md:min-h-[60px] max-h-96 flex-shrink-0`}
  .gatsby-image-wrapper {
    ${tw`w-full h-full`}
    img {
      ${tw`object-contain max-w-full max-h-full`}
    }
  }
`

const Paragraph = styled.p`
  ${tw`text-black text-32 font-bold md:text-40 !leading-[130%] font-ubuntu px-offset md:px-offsetMd xl:px-24 mb-c80 max-w-screen-sm2xl`}
`

const WpAcfLogoTickerModuleBlock = ({ moduleData, direction }) => {
  
  const { title, logos, logosSecond } = moduleData.acfLogoTicker || {}
  const duplicatedLogos = [...logos, ...logos, ...logos, ...logos] // Quadruple the logos for smooth scroll
  const duplicatedLogos2 = logosSecond ? [...logosSecond, ...logosSecond, ...logosSecond, ...logosSecond] : [] // Quadruple the logos for smooth scroll

  const directionSecond = direction === "left" ? "right" : "left"
  return (
    <Section>
      <Paragraph>{title}</Paragraph>
      <LogoTrack className="mb-10">
        <LogoRow direction={direction}>
          <LogoStrip>
            {duplicatedLogos.map((logo, index) => (
              <LogoContainer key={`logo-${index}`}>
                <GatsbyImage
                  objectFit="contain"
                  image={getImage(logo.localFile)}
                  alt={logo.altText || `Logo ${index + 1}`}
                />
              </LogoContainer>
            ))}
          </LogoStrip>
          <LogoStrip>
            {duplicatedLogos.map((logo, index) => (
              <LogoContainer key={`logo-clone-${index}`}>
                <GatsbyImage
                  objectFit="contain"
                  image={getImage(logo.localFile)}
                  alt={logo.altText || `Logo ${index + 1}`}
                />
              </LogoContainer>
            ))}
          </LogoStrip>
        </LogoRow>
      </LogoTrack>
      {duplicatedLogos2.length > 0 && <LogoTrack>
        <LogoRow direction={directionSecond}>
          <LogoStrip>
            {duplicatedLogos2.map((logo, index) => (
              <LogoContainer key={`logo-${index}`}>
                <GatsbyImage
                  objectFit="contain"
                  image={getImage(logo.localFile)}
                  alt={logo.altText || `Logo ${index + 1}`}
                />
              </LogoContainer>
            ))}
          </LogoStrip>
          <LogoStrip>
            {duplicatedLogos2.map((logo, index) => (
              <LogoContainer key={`logo-clone-${index}`}>
                <GatsbyImage
                  objectFit="contain"
                  image={getImage(logo.localFile)}
                  alt={logo.altText || `Logo ${index + 1}`}
                />
              </LogoContainer>
            ))}
          </LogoStrip>
        </LogoRow>
      </LogoTrack>
    }
    </Section>
  )
}

WpAcfLogoTickerModuleBlock.propTypes = {
  moduleData: PropTypes.object,
  direction: PropTypes.oneOf(["left", "right"]),
}

WpAcfLogoTickerModuleBlock.defaultProps = {
  moduleData: {},
  direction: "left",
}

export default WpAcfLogoTickerModuleBlock
